module.exports = __webpack_public_path__ + "static/media/oberflex-bamboufinambre-2560x1440.e2782da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-bamboufinambre-2560x1440.jpg
// module id = 985
// module chunks = 37